import React from 'react'

import { TARGET_TYPES } from 'components/attacks/create/targets/target-utils'
import SquareGlyph from 'components/common/SquareGlyph'
import SvgTargets from 'components/icons/Targets'
import { getTargetType } from 'components/scenarios/concurrent/attack-attributes'
import theme from 'theme'

import type { InfraAttackNode } from 'types/api/scenarios/scenario'

export const AttackGraphNodeTargetGlyph: React.FC<{
  node: InfraAttackNode
  showTargetType: boolean
}> = ({ node, showTargetType }) => {
  const targetType = getTargetType(node)

  const targetTypeDefinition = TARGET_TYPES[targetType]

  const TargetGlyph = showTargetType
    ? targetTypeDefinition.SvgGlyphIcon
    : SquareGlyph

  const TargetIcon = showTargetType ? targetTypeDefinition.SvgIcon : SvgTargets

  return (
    <TargetGlyph
      backgroundColor={theme.colors.gray[1]}
      css={{ height: 30, width: 30, marginRight: theme.space[2] }}
    >
      <TargetIcon
        css={{
          fontSize: theme.fontSizes[showTargetType ? 2 : 4],
          color: theme.colors.steel[1]
        }}
      />
    </TargetGlyph>
  )
}
